module.exports = __webpack_public_path__ + "static/media/darma.8c986521.webp";